import type { ICurrencyEnum } from "@jti/magento";

import { useCartPrices } from "@checkout-v2/shared/hooks/useCartPrices";

export const useCurrency = (): ICurrencyEnum | undefined => {
  const { data: prices } = useCartPrices();

  return prices?.subtotalIncludingTax?.currency as ICurrencyEnum | undefined;
};
